// extracted by css-extract-rspack-plugin
export default {"Borderless":"A2iWR","Border":"PzYoz"};